import Invoice from 'model/Invoice'
import globalFnFactory from 'components/globalFn/globalFnFactory'
import utils from 'utils'

const globalFn = globalFnFactory()
class modalSynInvoicCtrl {
    constructor($scope, $uibModalInstance, items1, openedInvoiceService, $timeout, logger, httpRequest, scrollService) {
        $scope = $.extend($scope, items1)
        $scope.changeTask = function (changeFlag) // -1上一条 1下一条
        {
            if (($scope.currentIndex <= 0 && changeFlag == -1) || ($scope.currentIndex >= ($scope.invoiceIdList.length - 1)) && changeFlag == 1) {
                return
            }
            if (changeFlag == 1) {
                $scope.currentIndex += 1
            } else if (changeFlag == -1) {
                (
                    $scope.currentIndex -= 1
                )
            }
            $scope.showPreTask = $scope.currentIndex != 0
            $scope.showNextTask = $scope.currentIndex != ($scope.invoiceIdList.length - 1)
            $scope.init($scope.invoiceIdList[$scope.currentIndex])
        }

        function getwaitListpage(pageInfo, isLoading) {
            isLoading && utils.loading('正在加载数据，请耐心等待......')
            $scope.invoiceText = $scope.invoice.invType === '0' ? '专用' : '普通'
            httpRequest.post_getPageInvoiceDetail(pageInfo).then((res) => {
                $scope.currentDetail = null
                $scope.currentDetail = res.data.value
                if ($scope.currentDetail.isLastPage && $scope.currentDetail.size < 20 && !isLoading) {
                    $scope.newDetails = $scope.newDetails ? $scope.newDetails.concat($scope.currentDetail.list) : [].concat($scope.currentDetail.list)
                } else {
                    $scope.newDetails = []
                    $scope.newDetails = $scope.currentDetail.list
                }
                utils.loaded()
            })
        }
        $scope.init = function (id) {
            $scope.isList === '0' && utils.loading('正在加载数据，请耐心等待......')
            httpRequest.post_getOvatInvoice(id).then((res) => {
                $scope.param = res.data.value
                $scope.invoice = new Invoice(res.data.value)
                $scope.invoice.chineseAmtTotal = globalFn.digitUppercase($scope.invoice.adValoremTotal)
                $scope.loadSize = 50
                $scope.pageParam = {
                    pageNum: 1,
                    pageSize: 50,
                    param: {
                        invoiceID: id,
                    },
                }
                $scope.isList === '0' && utils.loaded()
                $scope.isList === '1' && getwaitListpage($scope.pageParam, 1)
            })
        }
        $scope.onScrollTop = function () {
            $scope.pageParam = scrollService.onScrollTop($scope.currentDetail, $scope.pageParam, $scope.loadSize, getwaitListpage)
        }
        $scope.onScrollDown = function () {
            $scope.pageParam = scrollService.onScrollDown($scope.currentDetail, $scope.pageParam, $scope.loadSize, getwaitListpage)
        }
        // console.log($scope.isList)
        $scope.printTips = $scope.isList === '0' ? '您正在进行打印发票的操作，请确保您选择的发票是否与打印机上的纸质发票对应！' : '销货清单打印'
        $scope.modaldata = {
            invType: '',
            reason: '',
        }
        if ($scope.manageType && $scope.manageType != '2' || !$scope.manageType) {
            if ($scope.invType === '2') {
                $scope.modaldata.invType = $scope.isList === '0' ? 'c_FP' : 'c_QD'
            } else {
                $scope.modaldata.invType = $scope.isList === '0' ? 's_FP' : 's_QD'
            }
            if ($scope.invType === '41') {
                $scope.modaldata.invType = 'jp_FP'
            }
            if ($scope.invType === '12') {
                $scope.modaldata.invType = 'jdc_FP'
            }
            if ($scope.isList || $scope.isList === '0') {
                $scope.currentIndex = 0
                $scope.showPreTask = $scope.currentIndex != 0
                $scope.showNextTask = $scope.currentIndex != ($scope.invoiceIdList.length - 1)
                $scope.init($scope.invoiceIdList[0])
                openedInvoiceService.getPrinterNameList({}).then((res) => {
                    if (!res.list) logger.logError(res.retmsg)
                    $timeout(() => {
                        console.log($scope.modaldata.invType)
                        $scope.printerList = res.list || []
                        $scope.printerName = res[$scope.modaldata.invType] || $scope.printerList[0]
                    })
                }, () => {
                    logger.logError('获取打印机列表失败，请确认已开启金税盘')
                })
            }
        }

        if (($scope.isList || $scope.isList === '0') && $scope.manageType == '2') {
            $scope.currentIndex = 0
            $scope.showPreTask = $scope.currentIndex != 0
            $scope.showNextTask = $scope.currentIndex != ($scope.invoiceIdList.length - 1)
            $scope.init($scope.invoiceIdList[0])
            const printHelperParam = JSON.parse(localStorage.getItem("printHelperParam")) || {}
            if (!printHelperParam.printHelperIsConnect) {
                logger.logError('获取打印机列表失败，请确认已启动打印助手')
            }

            httpRequest.post_getInvoicePrintConfPage({}).then(res => {
                let currSelPrinterName = ''
                res.data.value.forEach(item => {
                    if (item.ukeyId == $scope.ukeyId && item.mngType == $scope.manageType && item.invType == $scope.invType) {
                        currSelPrinterName = item.printerName
                    }
                })
                $scope.printerList = printHelperParam.printerlist.reduce((total, curr) => {
                    if (curr.default === '1') {
                        $scope.printerName = currSelPrinterName || curr.name
                    }
                    total.push(curr.name)
                    return total
                }, [])
            })
        }
        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }

        function replaceName(str) {
            const arr = str.split('/')
            return arr.join('\/')
        }
        // 确定
        $scope.ok = function ok() {
            if ($scope.modaldata.reason) {
                $scope.invoiceList.forEach((invoice) => {
                    invoice.cancelReason = $scope.modaldata.reason
                })
            }
            $scope.modaldata.printerName = $scope.printerName

            if ($scope.manageType == '2') {
                $uibModalInstance.close($scope.modaldata)
                return
            }

            if (($scope.isList || $scope.isList === '0')) {
                openedInvoiceService.setPrinterName({
                    printerKindName: $scope.modaldata.invType,
                    printerName: replaceName($scope.printerName),
                }).then((res) => {
                    if (res.retcode == 1) {
                        logger.logSuccess('打印机设置成功')
                        // 返回数据
                        $uibModalInstance.close($scope.modaldata)
                    } else {
                        logger.logError(res.retmsg || '打印机设置失败')
                    }
                })
            } else {
                $uibModalInstance.close($scope.modaldata)
            }
        }
    }
}

modalSynInvoicCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'openedInvoiceService', '$timeout', 'logger', 'httpRequest', 'scrollService']
export default modalSynInvoicCtrl


// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/openedInvoice/modalSurePrint.js